import { useQuery } from "@tanstack/react-query";
import { BulkTest, BulkTestStatusType, emptyPage, Page } from "@/model";
import bulkTestRepository from "@/repository/bulkTestRepository";


const getData = async (
    agentId: number,
    page: number,
    size: number,
    sortKey: "created_at" | "success_rate",
    sort: "asc" | "desc",
    status?: BulkTestStatusType,
    keyword?: string
) => {
    const res = await bulkTestRepository.find(agentId, page, size, sortKey, sort, status, keyword);
    return res.data?.data || emptyPage<BulkTest>();
};

export const usePaginatedBulkTests = (
    agentId: number,
    page: number,
    size: number,
    sortKey: "created_at" | "success_rate",
    sort: "asc" | "desc",
    status?: BulkTestStatusType,
    keyword?: string
) => {
    return useQuery<Page<BulkTest>>({
        queryKey: ['page-bulk-tests', "agent", agentId, "page", page, "size", size, "sortKey", sortKey, "sort", sort, "status", status, "keyword", keyword],
        queryFn: async () => getData(agentId, page, size, sortKey, sort, status, keyword),
        retry: false
    });
};
